<template>
    <div>
        <modal
                :width="500"
                height="auto"
                name="m-zone">
            <div class="modal-dialog abtg-modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title abtg__modal-title" >Zona</h5>

                        <div class="tools">
                            <div class="abtg__close-button"><a @click="closeModal()"><i
                                    class="fas fa-times"></i></a></div>
                        </div>
                    </div>
                    <form @submit.prevent="onSubmit()">
                        <div class="modal-body">
                            <div class="row">
                                <div class="col">
                                    <div class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label txt-width">
                                        <input class="mdl-textfield__input abtg__input" name="price" type="text"
                                               v-model="content.formData.zone">
                                        <label class="abtg__label-select">Zona<span
                                                class="abtg__asterisk">*</span></label>
                                        <p class="text-danger small "></p>
                                    </div>
                                </div>
                                <div class="col">
                                    <div class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label txt-width">
                                        <input class="mdl-textfield__input abtg__input" name="price" type="text"
                                               v-model="content.formData.macrozone">
                                        <label class="abtg__label-select">Macro Zona<span
                                                class="abtg__asterisk">*</span></label>
                                        <p class="text-danger small "></p>
                                    </div>
                                </div>
                                <div class="col">
                                    <div class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label txt-width">
                                        <input class="mdl-textfield__input abtg__input" name="price" type="text"
                                               v-model="content.formData.microzone">
                                        <label class="abtg__label-select">Micro Zona<span
                                                class="abtg__asterisk">*</span></label>
                                        <p class="text-danger small "></p>
                                    </div>
                                </div>

                            </div>
                        </div>
                        <div class="modal-footer">

                            <button type="submit" class="margin-right-10 btn-success float-right abtg__btn-star">
                                Salva
                            </button>
                            <div style="margin-bottom:30px;height:30px;">&nbsp;</div>
                        </div>

                    </form>
                </div>
            </div>
        </modal>
    </div>

</template>
<script>
    export default {
        props: ['content'],
        data() {
            return {

            }
        },

        methods: {
            onSubmit: function () {
                this.$emit('editZoneData');
                this.closeModal();
            },
            closeModal: function () {
                this.$emit('closeModal','m-zone');
            },


        }
    }
</script>